import { createContext } from 'react';

interface LedDebugContextModel {
  setColor: (color: string) => void;
}

export default createContext<LedDebugContextModel>({
  setColor: () => {},
});
